import { useCallback, useState } from "react"

export type useSelectionYields = {
  selected: Array<string>
  onSelect: (selected: string) => void
  onSelectAll: () => void
  clearSelected: () => void
}

export type useSelectionProps = {
  all?: Array<string>
  onAdd?: (id: string) => void
  onRemove?: (id: string) => void
  onClear?: () => void
}

export function useSelection({
  all,
  onAdd,
  onRemove,
  onClear,
}: useSelectionProps = {}): useSelectionYields {
  const [selected, setSelected] = useState<Array<string>>([])

  const onSelect = useCallback(
    (newSelected: string): void => {
      const add = (newSelected: string) => {
        setSelected((prevSelected) => [...prevSelected, newSelected])
      }
      const remove = (newSelected: string) => {
        setSelected((prevSelected) =>
          prevSelected.filter((prevId) => prevId !== newSelected),
        )
      }
      const exists = selected.includes(newSelected)
      if (!exists) {
        add(newSelected)
        onAdd?.(newSelected)
      } else {
        remove(newSelected)
        onRemove?.(newSelected)
      }
    },
    [selected, onAdd, onRemove],
  )

  const onSelectAll = (): void => {
    if (!all) return
    setSelected((prevSelected) => {
      // select none
      if (prevSelected.length === all.length) {
        onClear?.()
        return []
      }
      // select all
      if (!!onAdd)
        all.forEach((id) => {
          if (!selected.includes(id)) onAdd(id)
        })
      return all
    })
  }

  const clearSelected = (): void => {
    setSelected([])
    onClear?.()
  }

  return {
    selected,
    onSelect,
    onSelectAll,
    clearSelected,
  }
}
